import { createContext } from 'react';

export type Features = {
    Internationalization: string;
    GapClaim: string;
    UKTyreClaim: string;
    BankAccount: string;
    WheelDamage: string;
    CosmeticDamage: string;
    ActiveClaim: string;
};

export type SiteState = {
    brandId: number;
    brandStyles: string;
    brandSearchComplete: boolean;
    clientId: string;
    domain: string;
    audience: string;
    features: Features;
    language: string;
};

export const siteInitialState: SiteState = {
    brandId: 0,
    brandStyles: '',
    brandSearchComplete: false,
    clientId: '',
    domain: '',
    audience: '',
    features: {
        Internationalization: 'off',
        GapClaim: 'off',
        UKTyreClaim: 'off',
        BankAccount: 'off',
        WheelDamage: 'off',
        CosmeticDamage: 'off',
        ActiveClaim: 'off'
    },
    language: 'en'
};

export const SiteContext = createContext(siteInitialState);
